// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1baUB","top":"styles_top__11khy","left":"styles_left__1FeAH","description":"styles_description__2Hx9i"};